import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { Dialogs } from '@awesome-cordova-plugins/dialogs/ngx';

import { ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { SharedModule } from './components/shared/shared.module';

import { ModalController } from '@ionic/angular';
import { CookieService } from 'ngx-cookie-service';
import { StoreModule } from '@ngrx/store';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { MobileModule } from './components/mobile/mobile.module';
import { reducers, metaReducers } from "src/app/reducers";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { environment } from '../environments/environment';
import { V2ModalsModule } from './modals/v2/v2.modals.module';

@NgModule({
    declarations: [
        AppComponent
    ],
    entryComponents: [],
    imports: [
        BrowserModule,
        StoreModule.forRoot(reducers, {
            metaReducers,
        }),
        StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
        IonicModule.forRoot(),
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        CommonModule,
        IonicModule,
        FontAwesomeModule,
        SharedModule,
        NgxGoogleAnalyticsModule.forRoot(environment.gaToken),
        NgxGoogleAnalyticsRouterModule,
        MobileModule,

        V2ModalsModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        Dialogs,
        ReactiveFormsModule,
        ModalController,
        CookieService,
        Title,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(library: FaIconLibrary) {
        library.addIconPacks(fas, fab, far);
    }
}
